import { Autocomplete } from '@react-google-maps/api'
import { ChangeEvent, useRef } from 'react'

import { DefaultInput } from 'src/components/atoms/DefaultInput'
import { ParagraphSmaller } from 'src/components/atoms/Typography'

import { FormFieldTypes } from 'src/types/form'
import { GeoData } from 'src/types/map'
import { getRegionDistrictFromPlace } from 'src/utils/map'

const AUTOCOMPLETE_OPTIONS: google.maps.places.AutocompleteOptions = {
  componentRestrictions: { country: 'nz' }
}

export interface MapAutocompleteProps {
  className?: string
  description?: string | JSX.Element
  id: string
  label: string
  onChange: (e: ChangeEvent<HTMLInputElement>) => void
  onSelectPlace: (placeGeo: GeoData) => void
  placeholder?: string
  value: string
}
export const MapAutocomplete = ({
  className = '',
  description,
  id,
  label,
  onChange,
  onSelectPlace,
  placeholder,
  value
}: MapAutocompleteProps) => {
  const autocompleteRef = useRef<google.maps.places.Autocomplete | undefined>(
    undefined
  )

  const handleLoad = (
    autocomplete: google.maps.places.Autocomplete | undefined
  ) => {
    if (autocomplete) autocompleteRef.current = autocomplete
  }

  const handlePlaceChanged = () => {
    if (autocompleteRef.current) {
      const componentRegionForm = {
        administrative_area_level_1: ['long_name', 'region'],
        administrative_area_level_2: ['short_name', 'district'],
        street_number: ['short_name', 'street_number'],
        route: ['long_name', 'street_name'],
        locality: ['long_name', 'city'],
        country: ['long_name', 'country'],
        postal_code: ['long_name', 'postal_code']
      }

      const place = autocompleteRef.current.getPlace()
      const placelatLng = place?.geometry?.location

      if (place?.address_components && placelatLng) {
        const regionDistrict = getRegionDistrictFromPlace(
          place.address_components,
          componentRegionForm
        )

        const placeGeo = {
          lat: placelatLng.lat(),
          lng: placelatLng.lng(),
          place_id: place.place_id,
          ...regionDistrict
        }

        onSelectPlace(placeGeo)
      }
    }
  }

  return (
    <Autocomplete
      className={className}
      onLoad={handleLoad}
      onPlaceChanged={handlePlaceChanged}
      options={AUTOCOMPLETE_OPTIONS}
    >
      <div className='form-group mb-5!'>
        <label className='form-label' htmlFor={id}>
          {label}
        </label>
        {typeof description === 'string' ? (
          <ParagraphSmaller className='form-description-text'>
            {description}
          </ParagraphSmaller>
        ) : (
          description
        )}
        <DefaultInput
          id={id}
          onChange={onChange}
          placeholder={placeholder}
          type={FormFieldTypes.text}
          value={value}
        />
      </div>
    </Autocomplete>
  )
}
